import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
// import LoginLogo from "../../assets/images/png/LoginLogo.png"
import OTPInput, { ResendOTP } from "otp-input-react";
import LoginAunty from "../../assets/images/png/girlFile.png";
import { FiChevronRight } from "react-icons/fi";
import i18n from "../../i18n";
import { useNavigate, useParams, Link, useHistory } from "react-router-dom";
import { BsX } from "react-icons/bs";
import Loader from "../../uiComponents/loader/Loader";
import "./fewMoreDetail.scss";
import "./newsignup.scss";
import logo1 from "../../assets/images/svg/newDesign/logo1.svg";
import back from "../../assets/images/svg/newDesign/back.svg";
import backMobile from "../../assets/images/svg/newDesign/backMobile.svg";
import logo from "../../assets/images/svg/newDesign/logo.svg";
import call from "../../assets/images/svg/newDesign/call.svg";
import drimage from "../../assets/images/svg/newDesign/DoctorImage.svg";
import { setDefaultNamespace } from "i18next";
import { useEffectOnce } from "react-use";
import { APIV3 } from "../../utils/customAxios";
import loadingGif from "../../assets/images/gif/loader_gif.gif";
import { toast } from "react-toastify";
import encryptStorage from "../../utils/encryptStorage";
// import Select from "@mui/material/Select";
import { Form, Input, Select } from "antd";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Chip, InputLabel } from "@mui/material";
import { useForm } from "antd/lib/form/Form";
import arrowIcon from "../../assets/images/svg/arrowIcon.svg";
import Cookies from "js-cookie";

const SignupDetails = () => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:767px)");
  let footerBaseUrl = process.env.REACT_APP_FOOTER_BASE_URL;
  let phone = encryptStorage.getItem("phoneLogin");
  const [name, setName] = useState("");
  const [city, setCity] = useState(null);
  const [email, setEmail] = useState("");
  const [pmc, setPmc] = useState("");
  const [specialities, setSpecialities] = useState(null);
  const [apiLoading, setApiLoading] = useState(true);
  const [cities, setCities] = useState(null);
  const [mobile, setMobile] = useState("");
  // const [speciality, setSpeciality] = useState(null);
  const [apiError, setApiError] = useState(false);
  const [signupError, setSignupError] = useState("");
  const [signupLoading, setSignupLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [formErrors, setFormErrors] = useState({
    nameError: "",
    cityError: "",
    pmcError: "",
    specialityError: "",
    emailError: "",
  });
  const { Option } = Select;
  const [form] = useForm();
  const [speciality, setSpeciality] = React.useState([]);

  const handleChange = (value) => {
    setSpeciality(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const navigateToLogin = () => {
    Cookies.remove("token");
    window.location.href = "https://gc-revamp-staging.greenclinic.pk/login";
  };

    // New: Check if all mandatory fields are filled
  const isFormValid =
    !name  ||
    !email ||
    !city ||
    speciality?.length === 0;

  useEffectOnce(() => {
    let loadSuccessFlag;
    let loadSuccessFlag2;
    (async () => {
      setApiLoading(true);
      let phoneNumber = phone;
      setMobile(phoneNumber);
      const response = await APIV3.get("/doctor/specialities");
      if (response?.status == 200) {
        setSpecialities(response?.data?.data);
        loadSuccessFlag = true;
      } else {
        loadSuccessFlag = true;
        setApiError(true);
      }
      const cityResponse = await APIV3.get("/doctor/cities");
      if (cityResponse?.status == 200) {
        setCities(cityResponse?.data?.data);
        loadSuccessFlag2 = true;
      } else {
        setApiError(true);
      }
      if (loadSuccessFlag && loadSuccessFlag2) {
        setApiLoading(false);
      }
    })();
  });

  const signupWait = (e) => {
    e.preventDefault();
    history.push("/please-wait");
  };

  const emailValidate = (e) => {
    const emailValue = e.target.value;
    const emailRegex =
      /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/gm;

    if (emailValue === "") {
      setEmail("");
      setEmailError("");
    } else if (!emailRegex.test(emailValue)) {
      setEmail(emailValue);
      setEmailError("Email should be valid");
      // Handle the invalid email address
    } else {
      setEmailError("");
      setEmail(emailValue);
      // Handle the valid email address
    }
  };

  const gotToThanks = () => {
    history.replace("/thanks-availability");
  };

  async function handleSubmit(e) {
    // e?.preventDefault();
    setFormErrors({});
    const otp = encryptStorage.getItem("otp");
    let errors = {};
    if (!name) {
      errors = { ...errors, nameError: "Name is required" };
    } else if (name.trim().length < 2) {
      errors = { ...errors, nameError: "Name must be at least 2 characters" };
    }
    if (!email) {
      errors = { ...errors, emailError: "Email is required" };
    }
    if (!city) {
      errors = { ...errors, cityError: "City is required" };
    }
    if (speciality?.length === 0) {
      errors = { ...errors, specialityError: "Please select your specialty." };
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      let data = {
        name,
        speciality: speciality?.map((item) => item),
        city,
        pmc_number: pmc,
        phone: mobile,
        otp,
        email,
      };
      try {
        setSignupLoading(true);
          setApiLoading(true)
        const response = await APIV3.post("/doctor/registration", data);
        if (response?.status == 200) {
          setSignupLoading(false);
          setApiLoading(false)
          encryptStorage.setItem(
            "unique_code",
            response?.data?.data?.unique_code
          );
          history.replace("/thanks-availability");
        } else {
          setSignupLoading(false);
          setApiLoading(false)
          setSignupError(response?.data?.message || "Something went wrong");
        }
      } catch (error) {
        setSignupLoading(false);
          setApiLoading(false)
        setSignupError(error?.response?.data?.message || error?.message);
      }
    }
  }

  console.log({apiLoading})

  return (
    <>
      <StyledLoginOtp className="signupDetails">
        {apiLoading || apiError ? (
          <div className="loaderWrapper">
            <img src={loadingGif} alt="" />
          </div>
        ) : (
          <>
            <div className={`${!isMobile ? "header_meriSehat" : ""}`}>
              <Container fluid>
                {apiLoading && <Loader />}

                {!isMobile && (
                  <Row>
                    <Col md={12}>
                      <div className="logo_only">
                        {/* <Link to="/"> */}
                        <img src={logo} className="logoEU" alt="Logo" />
                        {/* </Link> */}

                        <p className="phoneNumber">
                          <img src={call} className="logoEU" alt="Logo" />
                          (021)-111-111-111
                        </p>
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>
            </div>
            <Container>
              {/* <div className='LogoStyled'>
         <img src={LoginLogo} alt="logo" />
            </div> */}

              <Row className="hk_for_center imaging">
                <Col lg={12} className="backBtn">
                  <h5 style={{ cursor: "pointer" }}>
                    <img
                      src={!isMobile ? back : backMobile}
                      className="back"
                       onClick={navigateToLogin}
                    ></img>
                    Create Account
                  </h5>
                </Col>

                <Col md={12} className="formBoxSignUpContainer">
                  <div className="formBoxSignUp">
                    <Row>
                      {!isMobile && (
                        <Col lg={5} className="pe-0">
                          <img src={drimage} className="img-fluid"></img>
                        </Col>
                      )}
                      <Col lg={6} style={{ margin: !isMobile ? "auto 0" : "" }}>
                        <div className="white-form detailssForm">
                          <div className="spacingForm">
                            <Form
                              className="form"
                              autoComplete="off"
                              onFinish={handleSubmit}
                              form={form}
                            >
                              <Row>
                                <Col lg={6}>
                                  <div className="formHead">
                                    <h2 className="labelHead">Name*</h2>
                                    <input
                                      placeholder="Enter your name"
                                      className="detail-form detailFormfield"
                                      value={name}
                                      maxLength={30}
                                      onChange={(e) => {
                                        const inputName = e.target.value;
                                          const regex = /^[A-Za-z ]*$/;
                                        if (inputName === "" || regex.test(inputName)) {
                                          setName(inputName);
                                        }
                                      }}
                                       onBlur={() => {
                                        let error = "";
                                        if (!name.trim()) {
                                          error = "Name is required";
                                        } else if (name.trim().length < 2) {
                                          error = "Name must be at least 2 characters";
                                        } else if (!/^[A-Za-z ]+$/.test(name.trim())) {
                                          error = "Only alphabets and spaces are allowed";
                                        }
                                        setFormErrors((prev) => ({
                                          ...prev,
                                          nameError: error,
                                        }));
                                      }}
                                    />
                                    {formErrors?.nameError && (
                                      <p className="errorRequired">
                                        {" "}
                                        {formErrors?.nameError}{" "}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="formHead">
                                    <h2 className="labelHead">
                                      Mobile Number*
                                    </h2>
                                    <input
                                      value={mobile}
                                      className="detail-form detailFormfield"
                                      disabled
                                    />
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="formHead emailNewInput">
                                    <h2 className="labelHead">Email </h2>
                                    <Form.Item
                                      name="email"
                                      onChange={(e) => setEmail(e.target.value)}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Email is required",
                                        },
                                        {
                                          type: "email",
                                          message: "Invalid email format",
                                        },
                                      ]}
                                    >
                                      <Input
                                        type="email"
                                        placeholder="Enter your email address"
                                        value={email}
                                      />
                                    </Form.Item>
                                    {/* <input
                            type="email"
                            placeholder="Enter email address"
                            className="detail-form detailFormfield"
                            value={email}
                            onChange={emailValidate}
                          /> */}
                                    {/* {emailError ? (
                                 <p className="errorRequired">
                                 {" "}
                                 {emailError}{" "}
                               </p>
                          ) : null} */}
                                    {formErrors?.emailError ? (
                                      <p className="errorRequired">
                                        {" "}
                                        {formErrors?.emailError}{" "}
                                      </p>
                                    ) : (
                                      signupError && (
                                        <p className="red-error">
                                          {" "}
                                          {signupError}{" "}
                                        </p>
                                      )
                                    )}
                                    {/* {signupError && <p className="red-error"> {signupError} </p>} */}
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="formHead">
                                    <h2 className="labelHead">City*</h2>
                                    <Form.Item
                                      name="city"
                                      className="selectSpeciality citySelectSpe"
                                    >
                                      <Select
                                        showSearch={false}
                                        optionFilterProp="children"
                                         rules={[
                                        {
                                          required: true,
                                          message: "City is required",
                                        },
                                        ]}
                                        filterOption={(input, option) => {
                                          return option.props.children?.[1]
                                            .toString()
                                            .toLowerCase()
                                            .startsWith(input.toLowerCase());
                                        }}
                                        suffixIcon={
                                          <img src={arrowIcon} alt="Dropdown" />
                                        }
                                        showArrow
                                        placeholder="Select your city"
                                        value={city}
                                        // label="name"
                                        onChange={(e) => setCity(e)}
                                        style={{ width: "100%" }}
                                        MenuProps={{
                                          MenuListProps: {
                                            style: {
                                              maxHeight: "500px",
                                              overflowY: "auto",
                                            },
                                          },
                                        }}
                                      >
                                        {cities?.map((city, index) => (
                                          <Option
                                            key={index}
                                            value={city?.name}
                                          >
                                            {" "}
                                            {city?.name}{" "}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>

                                    {formErrors?.cityError && (
                                      <p className="errorRequired">
                                        {" "}
                                        {formErrors?.cityError}{" "}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="formHead">
                                    <h2 className="labelHead"> Speciality*</h2>
                                    <Form.Item
                                      name="Medical Speciality*"
                                      className="selectSpeciality selectSpeciality    selectSpeciality citySelectSpe"
                                    >
                                      <Select
                                        className="placeholder-left"
                                        // filterOption={(input, option) =>
                                        //   option.props.children.toLowerCase().startsWith(input.toLowerCase())
                                        // }

                                        suffixIcon={
                                          <img src={arrowIcon} alt="Dropdown" />
                                        }
                                         rules={[
                                        {
                                          required: true,
                                          message: "Please select your specialty.",
                                        },
                                        ]}
                                        showArrow
                                        placeholder="Select your specialty "
                                        mode="multiple"
                                        value={speciality}
                                        label="name"
                                        allowClear
                                        onChange={(value) =>
                                          handleChange(value)
                                        }
                                        showSearch={true}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => {
                                          return option.children
                                            ?.toString()
                                            .toLowerCase()
                                            .startsWith(input.toLowerCase());
                                        }}
                                        style={{ width: "100%" }}
                                        MenuProps={{
                                          // getContentAnchorEl: null,
                                          // anchorOrigin: {
                                          //   vertical: "bottom",
                                          //   horizontal: "left",
                                          // },
                                          MenuListProps: {
                                            style: {
                                              maxHeight: "500px",
                                              overflowY: "auto",
                                            },
                                          },
                                        }}
                                      >
                                        {specialities?.map((spec, index) => (
                                          <Option key={index} value={spec?.id}>
                                            {spec?.name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </Form.Item>

                                    {formErrors?.specialityError && (
                                      <p className="errorRequired">
                                        {" "}
                                        {formErrors?.specialityError}{" "}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg={6}>
                                  <div className="formHead pmdc-number-last">
                                    <h2 className="labelHead">
                                      PMDC Number{" "}
                                      <span className="ms-1 ms-1 ">
                                        (not mandatory for all)
                                      </span>
                                      <span className="d-lg-none">*</span>
                                    </h2>
                                    {/* <input
                                placeholder="Enter PMDC number"
                                className="detail-form detailFormfield"
                                value={pmc}
                                onChange={(e) => {
                                  const inputNumber = e.target.value;
                                  const regex = /^[A-Za-z0-9]{0,7}$/; // Regular expression to match up to 7 digits
                                  if (inputNumber === '' || regex.test(inputNumber)) {
                                    setPmc(inputNumber);
                                  }
                                }}

                              /> */}
                                    <input
                                      placeholder="Enter PMDC number"
                                      className="detail-form detailFormfield"
                                      value={pmc}
                                      onChange={(e) => {
                                        const inputNumber = e.target.value;
                                       const regex = /^[A-Za-z0-9]{0,7}$/; // Allow up to 7 alphanumeric characters
                                        if (inputNumber === "" || regex.test(inputNumber)) {
                                          setPmc(inputNumber);
                                        }
                                      }}
                                      inputMode="text"
                                      pattern="[A-Za-z0-9]*"
                                    />

                                   {formErrors?.pmcError && (
                                      <p className="errorRequired">
                                        {" "}
                                        {formErrors?.pmcError}{" "}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                {!isMobile && (
                                  <Col lg={12}>
                                    <div className="Otp-continue-btn w-100">
                                      <button
                                        type="submit"
                                        disabled={signupLoading || isFormValid}
                                         style={{opacity: isFormValid ? '0.2' : '', color: isFormValid ? '#fff' : ''}}
                                        className="review-button text-uppercase signupDetails-phone-btn position-relative"
                                      >
                                        Continue
                                      </button>
                                    </div>
                                  </Col>
                                )}
                              </Row>

                              {/* <div className="formHead selectParent row">
                          <Col md={12}>
                            <h2 className="labelHead" >City*</h2>
                            <select
                              placeholder="Select your city"
                              className="details-select detailFormfield"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                            >
                              <option
                                className="details-select-option"
                                disabled
                                selected
                                hidden
                              >
                                {" "}
                                Select city{" "}
                              </option>
                              {cities?.[0]?.map((city, index) => (
                                <option key={index} value={city?.name}>
                                  {" "}
                                  {city?.name}{" "}
                                </option>
                              ))}
                            </select>
                            {formErrors?.cityError && (
                              <p className="errorRequired">
                                {" "}
                                {formErrors?.cityError}{" "}
                              </p>
                            )}
                          </Col>
                        </div> */}
                              {!isMobile && (
                                <div className="description-details col-md-8 m-auto">
                                  <p className="termsParaa terms-privacy d-none">
                                    By creating an account, you agree with our{" "}
                                    <a
                                      target="_blank"
                                      href={`${footerBaseUrl}/page/terms-conditions`}
                                      className="termsConditions"
                                    >
                                      {" "}
                                      Terms & Conditions{" "}
                                    </a>
                                    and
                                    <a
                                      target="_blank"
                                      href={`${footerBaseUrl}/page/privacy-policy`}
                                      className="termsConditions"
                                    >
                                      {" "}
                                      Privacy Statement{" "}
                                    </a>
                                  </p>
                                  <p className="alreadyAccountPara mt-2">
                                    Already have an account?{" "}
                                    <a
                                      onClick={navigateToLogin}
                                      style={{ color: "#19B3B5" }}
                                      className="fw-700"
                                    >
                                      Login
                                    </a>{" "}
                                    here.
                                  </p>
                                </div>
                              )}
                            </Form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {isMobile && (
                    <>
                      <div className="Otp-continue-btn w-100">
                        <button
                          type="button"
                          disabled={signupLoading}
                          className="review-button text-uppercase signupDetails-phone-btn position-relative"
                          onClick={handleSubmit}
                        >
                          Continue
                        </button>
                      </div>
                      <div className="description-details col-md-8 m-auto">
                        <p className="alreadyaccount mt-2">
                          Already have an account?{" "}
                          <a
                            onClick={navigateToLogin}
                            style={{ color: "#19B3B5" }}
                            className="fw-700"
                          >
                            Login
                          </a>{" "}
                          here.
                        </p>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </Container>
          </>
        )}
      </StyledLoginOtp>
    </>
  );
};

export const StyledLoginOtp = styled.section`
  .white-form {
    .selectSpeciality {
      .anticon svg {
        fill: #313131;
      }
    }

    .detail-form {
      width: 100%;
      margin-top: 5px;
      margin-bottom: 5px;
      border: 0.5px solid #959494;
      border-radius: 10px;
      padding: 10px;
      height: 38px;
    }

    .details-select {
      width: 100%;
      margin-top: 5px;
      margin-bottom: 5px;
      border: 0.5px solid #959494;
      border-radius: 10px;
      padding: 5px 10px;
      height: 38px;
    }

    h2 {
      font-family: "Satoshi-Light";
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 23px;
      display: flex;
      align-items: center;
      color: #313131;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */

      display: flex;
      align-items: center;

      color: #313131;
    }
  }

  .description-details {
    margin: 15px 0;
    p {
      font-family: "Satoshi-Light";
      font-style: normal;
      font-weight: 300;
      font-size: 11px;
      line-height: 140%;

      text-align: center;
      letter-spacing: 0.01em;
      color: #404040;
    }
  }
  a {
    color: #e9406a;
  }

  .image-below {
    position: fixed;
    left: 0;
    bottom: 0;
  }

  .alreadyAccountPara {
    font-family: "Satoshi-Light";
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 140%;

    text-align: center;
    letter-spacing: 0.01em;

    color: #404040;
  }
`;

export default SignupDetails;
 